import { get } from "../../../../shared/data";

const noImage = { src: "/images/noimage.jpg", alt: "no image" };

export const getImageData = (wipKey, shots) => {
    const frontView = shots.find((shot) => shot.imageView === "SM 1");
    const useShot = frontView ? frontView : shots[0];

    if (!useShot) {
        return noImage;
    }

    return {
        src: useShot.uneditedImageUris.medium,
        alt: useShot.imageView,
    };
};

export const getShots = (wipKey) => {
    return get(`/photography/wips/${wipKey}/shots?isActive=true`);
};
